export const appRoles = {
    admin: 'Admin',
    creator: 'Creator',
    holiday: 'Holiday',
    humanResources: 'HumanResources',
    projectManager: 'ProjectManager'

}